export class MissingApiClientError extends Error {
  constructor() {
    super('API axios instance is not registered. Call registerApiAxiosInstance first.');
    this.name = 'MissingApiClientError';
  }
}

export class MissingNetworkErrorNotifierError extends Error {
  constructor() {
    super('Network error notifier is not registered. Call registerNetworkErrorNotifier first.');
    this.name = 'MissingNetworkErrorNotifierError';
  }
}

export class MissingNodeApiClientError extends Error {
  constructor() {
    super('Node API axios instance is not registered. Call registerNodeApiAxiosInstance first.');
    this.name = 'MissingNodeApiClientError';
  }
}
